import styled from 'styled-components';

import { Text, Space, theme } from 'components';

export const StyledBody = styled.div`
  background-color: ${theme.white};
`;

export const StyledPageHeader = styled.div`
  display: grid;
  grid-template-columns: auto minmax(200px, 1fr);
  grid-gap: 12px;
  align-items: baseline;
  margin-top: 10px;
  width: 100%;
  & > *:first-child {
    padding-top: 0px;
  }
`;

export const StyledHeaderActions = styled(Space)<{
  $md: boolean;
}>`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: ${({ $md }) => ($md ? 'flex-end' : 'flex-start')};
`;

export const StyledPaneTitle = styled(Text)<{ $active: boolean }>`
  color: ${({ $active }) =>
    $active ? theme.getColor('primary') : theme.getColor('textSecondary')};
`;

export const StyledUsersCount = styled(Text)<{ $hideMargin?: boolean }>`
  color: ${theme.gray8};
  margin-right: ${({ $hideMargin }) => ($hideMargin ? 0 : '16px')};
`;
